var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50456 8.9144C3.55329 8.84536 3.58578 8.77633 3.63857 8.72354C4.23552 8.12253 4.83246 7.52558 5.42941 6.92864C5.79895 6.5591 6.32686 6.55098 6.68016 6.90427C7.02127 7.24132 7.02533 7.78142 6.67204 8.14283C5.81519 9.0078 4.95429 9.8687 4.08933 10.7255C3.71573 11.0951 3.21624 11.091 2.84264 10.7174C1.97768 9.85652 1.11677 8.99968 0.259931 8.13065C-0.0933645 7.77736 -0.0811819 7.2332 0.263992 6.89615C0.613226 6.55504 1.13708 6.5591 1.49849 6.92051C2.15229 7.56619 2.80609 8.21593 3.50456 8.9144Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43196 2.08609C3.38323 2.15512 3.35074 2.22416 3.29795 2.27695C2.70101 2.87796 2.10406 3.4749 1.50711 4.07185C1.13757 4.44139 0.60966 4.44951 0.256365 4.09622C-0.0847477 3.75916 -0.0888089 3.21907 0.264486 2.85765C1.12133 1.99269 1.98223 1.13179 2.8472 0.274943C3.2208 -0.0945958 3.72028 -0.090535 4.09388 0.283065C4.95885 1.14397 5.81975 2.00081 6.67659 2.86984C7.02989 3.22313 7.01771 3.76729 6.67253 4.10434C6.3233 4.44545 5.79945 4.44139 5.43803 4.07997C4.78423 3.4343 4.13043 2.78456 3.43196 2.08609Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortActive);
export default __webpack_public_path__ + "static/media/sort_active.e7becf1dd9dfc36e389ab499b9dee573.svg";
export { ForwardRef as ReactComponent };